<template>
  <div class="step-add-ones position-relative">
    <div v-if="isViewOnly" class="protected-view" style="background: transparent"></div>
    <p class="title-check">Add Ons</p>
    <table>
      <tr v-for="(addOn, index) in addOns" :key="addOn.boat_extra_id + index" :class="'list-item list-item' + addOn.boat_extra_id">
        <th style="width: 40%" class="name-add">
          {{addOn.name}}
        </th>
        <th style="width: 30%">
          <div class="button-change-value" v-if="!!addOn.default_amount">
            <p class="text-intro">QTY</p>
            <div class="bar-value">
              <button @click="decreaseAddOnAmount('addon-amount-' + addOn.boat_extra_id, addOn.boat_extra_id)">−</button>
              <p class="text-value">{{addOn.amount ? addOn.amount : 0}}</p>
              <input type="number"
                     value="0"
                     @change="updateAddOnAmount('addon-amount-' + addOn.boat_extra_id, addOn.boat_extra_id)"
                     class="d-none form-control extra-input-amount" :id="'addon-amount-' + addOn.boat_extra_id">
              <button @click="increaseAddOnAmount('addon-amount-' + addOn.boat_extra_id, addOn.boat_extra_id)">+</button>
            </div>
          </div>
          <div class="yes-no-value" v-else>
            <div class="d-flex flex-column align-items-center">
              <p class="text-intro">YES</p>
              <button class="mt-1" :class="addOn.amount ? 'active' : ''" @click="changeAddOnIdValue(addOn.boat_extra_id, 1)">
                <img src="../../../assets/images/checkIcon.svg" alt="checkIcon" />
              </button>
            </div>
            <div class="d-flex flex-column align-items-center">
              <p class="text-intro">NO</p>
              <button class="mt-1 ml-2" :class="!addOn.amount ? 'active' : ''" @click="changeAddOnIdValue(addOn.boat_extra_id, 0)">
                <img src="../../../assets/images/XIcon.png" alt="Xicon" />
              </button>
            </div>
          </div>
        </th>
        <th style="width: 20%" class="price-one" v-text="parseInt(addOn.price) > 0 ? ('$' + addOn.price) : ''"></th>
        <th style="width: 10%" class="actions" v-if="!!addOn.default_amount">
          <img src="../../../assets/images/edit-icon.svg"/>
          <img class="ml-2" src="../../../assets/images/trash-icon.svg"/>
        </th>
      </tr>

      <!-- result -->
      <tr class="result-line">
        <th >Total</th>
        <th></th>
        <th v-text="'$' + addOnsTotalAmount"></th>
        <th></th>
      </tr>
    </table>
    <div class="mt-4 text-right" v-if="!isViewOnly">
        <button @click="onSave"
            type="button" class="btn-dialog ok-btn pl-5 pr-5" style="width: auto" v-text="'Save'"></button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'StepAddOnes',
  props: {
    items: {
      type: Array,
    },
    isViewOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      addOnsTotalAmount: 0,
      addOns: []
    }
  },
  watch: {
    items() {
      this.addOns = this.items
    },
    addOns() {
      this.$emit('updateAddOns', this.addOns)
    }
  },
  created() {
    this.addOns = this.items
  },
  methods: {
    changeAddOnIdValue(extraId, value) {
      const index = this.addOns.findIndex(addOn => addOn.boat_extra_id === extraId);
      this.addOns[index].amount = value;
      this.getAddOnTotalAmount()
      this.formDirty = true
    },
    getAddOnTotalAmount() {
      let total = 0
      for (const i in this.addOns) {
        if (this.addOns[i].default_amount) {
          total += this.addOns[i]?.amount ? (parseInt(this.addOns[i].amount) * this.addOns[i].price) : 0
        } else if (this.addOns[i].amount) {
          total += parseInt(this.addOns[i].price)
        }
      }

      this.addOnsTotalAmount = total
    },
    decreaseAddOnAmount(elementId, extraId) {
      const index = this.addOns.findIndex(item => item.boat_extra_id === extraId);
      const jElement = $('#' + elementId)
      let currentValue = parseInt(jElement.val());
      if (currentValue > 0) {
        currentValue -= 1
        this.addOns[index].amount = currentValue;
        jElement.val(currentValue);
        this.getAddOnTotalAmount()
      }
    },
    increaseAddOnAmount(elementId, extraId) {
      const index = this.addOns.findIndex(item => item.boat_extra_id === extraId);
      const jElement = $('#' + elementId)
      let currentValue = parseInt(jElement.val()) + 1;
      this.addOns[index].amount = currentValue;
      jElement.val(currentValue);
      this.getAddOnTotalAmount()
    },
    updateAddOnAmount(elementId, extraId) {
      const index = this.addOns.findIndex(item => item.boat_extra_id === extraId);
      this.addOns[index].amount = parseInt($('#' + elementId).val())
      this.getAddOnTotalAmount()
      this.formDirty = true
    },
    onSave() {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
  .step-add-ones {
    height: auto;
    width: 100%;
    user-select: none;
  }
  .title-check {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 40px;
    color: #1c5169;
  }
  table {
    width: 80%;
    user-select: none;
    tr {
      &:last-child {
        border-bottom: none;
      }
      &:nth-last-child(2) {
        border-bottom: 1.5px solid #2C94AB;
      }
      user-select: none;
      border-bottom: 1.5px solid #DEE6EA;
    }
    th {
      padding-top: 20px;
      user-select: none;
    }
    .name-add {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      color: #555E67;
    }
    .button-change-value {
      display: flex;
      flex-direction: column;
      width: max-content;
      align-items: center;
      margin-bottom: 25px;
    }
    .text-intro {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      text-align: center;
      letter-spacing: 0.08em;
      color: #7C7C7A;
    }
    .bar-value {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 130px;
      height: 40px;
      background: #1C5169;
      box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
      border-radius: 40px;
      margin-top: 10px;
      button {
        border: none;
        outline: none;
        color: #fff;
        font-size: 30px;
        background: initial;
      }
      .text-value {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 30px;
        line-height: 24px;
        color: #FFFFFF;
      }
    }
    .price-one {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      color: #555E67;
    }
    .actions {
      img {
        cursor: pointer;
      }
    }
    .result-line {
      th {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: #2C94AB;
      }
    }

    .yes-no-value {
      width: 130px;
      display: flex;
      margin-bottom: 25px;

      .active {
        background: #1c5169;
      }

      button {
        border: none;
        outline: none;
        background: #d9d9d9;
        box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 61px;
        height: 47px;
      }
    }
  }
  .protected-view {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 9990;
    opacity: 0.4;
  }
</style>
